import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';

const LogSlice = createSlice({
    name: 'logSlice',
    initialState: {
        CrudLogList: [],
        LoginLogList: [],
        getWorkOffice: [],
        checkInWorkOffice: {},
        checkOutWorkOffice: {},
        UserListAccess: [],
        VehicleListAccess: [],
        getAllUserAccessLogByUserId:[],
        getAllVehicleAccessLogByVehicleId:[]
    },
    reducers: {},
    extraReducers: {
        'logSlice/getCrudLogList/fulfilled': (state, action) => {
            state.CrudLogList = ResponseApi(action.payload);
        },
        'logSlice/getLoginLogList/fulfilled': (state, action) => {
            state.LoginLogList = ResponseApi(action.payload);
        },
        'logSlice/getWorkOffice/fulfilled': (state, action) => {
            state.getWorkOffice = ResponseApi(action.payload);
        },
        'logSlice/checkInWorkOffice/fulfilled': (state, action) => {
            state.checkInWorkOffice = ResponseApi(action.payload);
        },
        'logSlice/checkOutWorkOffice/fulfilled': (state, action) => {
            state.checkOutWorkOffice = ResponseApi(action.payload);
        },
        'logSlice/getUserAccessList/fulfilled': (state, action) => {
            state.UserListAccess = ResponseApi(action.payload);
        },
        'logSlice/getVehicleAccessList/fulfilled': (state, action) => {
              state.VehicleListAccess = ResponseApi(action.payload);
        },
        'logSlice/getAllUserAccessLogByUserId/fulfilled': (state, action) => {
            state.getAllUserAccessLogByUserId = ResponseApi(action.payload);
        },
        'logSlice/getAllVehicleAccessLogByVehicleId/fulfilled': (state, action) => {
              state.getAllVehicleAccessLogByVehicleId = ResponseApi(action.payload);
        },
    },
});

export const {} = LogSlice.actions;

export default LogSlice.reducer;
